import mapElements from '@/mixins/mapElements'

export default {
  name: 'Dashboard',
  data () {

  },
  mixins: [ mapElements ],
  methods: {
    mapChartInterval (value) {
      var interval = {
        '1d': 'hr_1',
        '7d': 'hr_2',
        '30d': 'hr_4',
        '12m': 'd_2',
        '5y': 'mo_1'
      }
      return interval[value]
    },
    mapChartIntervalIntro (value) {
      var interval = {
        '1d': 'ONE_DAY',
        '7d': 'SEVEN_DAYS',
        '30d': 'THIRTY_DAYS',
        '12m': 'TWELVE_MONTHS',
        '5y': 'FIVE_YEARS'
      }
      // console.log(interval[value])
      return interval[value]
    },
    setLabelData (date, interval, index) {
      const mv = this
      if (interval && (interval === '1d')) {
        return mv.formatLocaleHourChart(date)
      } else {
        return mv.formatLocaleDate(date)
      }
    },
    setChartData (data, kpiName, index) {
      const mv = this
      return {
        meta: mv.$t(kpiName),
        value: data.value
      }
    },
    mapListChartKpi (listData, stationName, interval, kpiSelected, entityType) {
      // console.log(listData)
      // console.log(stationName)
      // console.log(interval)
      // console.log(entityType)
      const mv = this
      let series = []
      var labels = []
      var list = null
      var intervalChart = null

      if (listData && listData.length) {
        listData.map((element) => {
          if (stationName && interval && kpiSelected) {
            if (element['stations']['station'][stationName]) {
              intervalChart = mv.mapChartInterval(interval)
              if (kpiSelected === 'totalCO2Absorption' || kpiSelected === 'co2AbsorptionByTreeSpecies' || kpiSelected === 'co2AbsorptionByBushesAndGardens') {
                intervalChart = 'mo_1'
              }
              if (kpiSelected === 'avgConsumption') {
                kpiSelected = 'avgconsumption'
              }
              switch (kpiSelected) {
                case 'totalCO2Absorption':
                  kpiSelected = 'totalCOAbsorption'
                  break
                case 'co2AbsorptionByBushesAndGardens':
                  kpiSelected = 'coAbsorptionByBushesAndGardens'
                  break
                case 'co2':
                  kpiSelected = 'co'
                  break
                case 'co2AbsorptionByTreeSpecies':
                  kpiSelected = 'coAbsorptionByTreeSpecies'
                  break
              }
              if (kpiSelected === 'totalCO2Absorption') {
              //   kpiSelected = 'totalCO2Absorption'
                intervalChart = 'd_2'
              }
              // if (kpiSelected === 'occupationRateSensorZones' || kpiSelected === 'occupationRateParking') {
              //   kpiSelected = 'occupationRate'
              // }
              intervalChart = 'hr_1'
              if (element['stations']['station'][stationName]['mean'][intervalChart]) {
                if (element['stations']['station'][stationName]['mean'][intervalChart][kpiSelected]) {
                  element['stations']['station'][stationName]['mean'][intervalChart][kpiSelected].map((element, index) => {
                    labels.push(mv.setLabelData(element.timestamp, interval))
                    series.push(mv.setChartData(element, kpiSelected))
                  })
                }
              }
            }
          }
        })
      }
      if (labels.length && series.length) {
        list = {
          labels: labels,
          series: [series]
        }
      }
      return list
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/mapChartsElements.js